import React from 'react';

const CONFETTI_COLORS = ['#FF0099', '#00FFDD', '#FFCC00', '#B89762', '#C29D52', '#FF6B6B'];

export const ConfettiBackground = () => (
  <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
    {Array.from({ length: 18 }).map((_, i) => (
      <div key={i} className="absolute" style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        width: `${5 + Math.random() * 8}px`,
        height: `${5 + Math.random() * 8}px`,
        borderRadius: Math.random() > 0.5 ? '50%' : '2px',
        background: CONFETTI_COLORS[i % 6],
        opacity: 0.1 + Math.random() * 0.12,
        animation: `confettiFall ${8 + Math.random() * 14}s linear infinite`,
        animationDelay: `${Math.random() * 10}s`,
      }} />
    ))}
    <style>{`@keyframes confettiFall { 0% { transform: translateY(-10vh) rotate(0deg); } 100% { transform: translateY(110vh) rotate(720deg); } }`}</style>
  </div>
);

export const PurpleGlowBg = () => (
  <div className="fixed inset-0 pointer-events-none z-0">
    <div className="absolute top-0 left-1/4 w-[600px] h-[600px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(108,92,231,0.1), transparent 70%)' }} />
    <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(62,198,231,0.07), transparent 70%)' }} />
  </div>
);
